import {
  UPDATE_USER_DATA,
  UPDATE_USER_ID,
  ENABLE_SHOW_ONBOARDING,
  RESET_USER,
  SET_FIRST_LOGIN
} from '../constants'

import {
  pathOr,
  isEmpty,
  path,
  propOr,
} from 'ramda'

import axios from '@/utils/axios'

// initial state
const initialState = () => ({
  userInfo: {
    id: '',
  },
  isFirstLogin: false,
})

const state = initialState()

// getters
const getters = {
  isElsaAdmin: pathOr(false, ['userInfo', 'is_superuser']),
  countryAdminLevel: pathOr(null, ['userInfo', 'country_admin_level']),
  activeOrganization: pathOr({}, ['userInfo', 'organizations', 0]),
  getUser: propOr({}, 'userInfo'),
  getUserId: path(['userInfo', 'id']),
  showOnboarding: (state, getters, rootState, rootGetters) => {
    const hasNoOrganizations = isEmpty(rootGetters['organization/userOrganizations'])
    const showOnboarding = state.showOnboarding

    return hasNoOrganizations && showOnboarding
  },
  
}

// actions
const actions = {
  loadUserData ({ commit, state }) {
    return axios.get(`/v1/accounts/${state.userInfo.id}`)
      .then(response => commit(UPDATE_USER_DATA, response.data))
  },
  updateUserData ({ commit }, data) {
    return axios.patch(`/v1/accounts/${data.id}`, { ...data })
      .then(response => commit(UPDATE_USER_DATA, response.data))
  },
  async updateCurrentUserId ({ commit, dispatch }, { userId }) {
    await commit(UPDATE_USER_ID, userId)

    return dispatch('loadUserData')
  },
  showOnboarding ({ commit }, { show = true }) {
    return commit(ENABLE_SHOW_ONBOARDING, show)
  },
  reset({ commit }) {
    return commit(RESET_USER)
  },
  setFirstLogin ({ commit }, firstLogin) {
    return commit(SET_FIRST_LOGIN, firstLogin)
  },
  removeUserFromSystem(_, {studentId} = {}) {
    return axios.delete(`/v1/accounts/${studentId}`)
  },
}

// mutations
const mutations = {
  [UPDATE_USER_DATA] (state, userData) {
    state.userInfo = { ...userData }
  },
  [UPDATE_USER_ID] (state, userId) {
    state.userInfo.id = userId
  },
  [ENABLE_SHOW_ONBOARDING] (state, enabled) {
    state.showOnboarding = enabled
  },
  [RESET_USER](state) {
    Object.assign(state, initialState())
  },
  [SET_FIRST_LOGIN] (state, firstLogin) {
    state.isFirstLogin = firstLogin
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
